import React from 'react';

const Parts = () => {
  return (
    <div>
      <h1>Parts</h1>
    </div>
  );
};

export default Parts;